export default __webpack_public_path__ + "static/media/Path3397.6686a2d7.svg";